import React, { createContext, useState, ReactNode, useContext } from 'react'

interface SearchAccessesContextType {
  searchText: string
  setSearchText: (text: string) => void
}

export const SearchAccessesContext = createContext<SearchAccessesContextType | undefined>(undefined)

export const SearchAccessesProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const [searchText, setSearchText] = useState<string>('')

  return (
    <SearchAccessesContext.Provider value={{ searchText, setSearchText }}>
      {children}
    </SearchAccessesContext.Provider>
  )
}

export const useSearchAccesses = () => {
  const context = useContext(SearchAccessesContext)
  if (!context) {
    throw new Error('useSearchAccesses must be used within a SearchAccessesProvider')
  }
  return context
}
